import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { CreateSubscriptionSuccess } from '@webapp/store/subscription/action-creators';
import { CREATE_SUBSCRIPTION_SUCCESS } from '@webapp/store/subscription/actions';
import { planDowngradedEvent } from '@webapp/utils/rudderstack/events';

export const trackDowngrade = (
  action$: Observable<CreateSubscriptionSuccess>
) =>
  action$.pipe(
    ofType(CREATE_SUBSCRIPTION_SUCCESS),
    filter((action) => action.change === 'DOWNGRADE'),
    map((action) => {
      if (window.analytics) {
        window.analytics.track('Plan Downgraded', {
          from: action.original?.product?.name,
          to: action.newSubscription.plan,
          frequency: action.newSubscription.frequency,
          totalAmount: action.newSubscription.price,
        });
      }

      planDowngradedEvent({
        from: action.original?.product?.name,
        to: action.newSubscription.plan,
      });
    }),
    filter(() => false)
  );
